import routeIcons from "../components/icons";
import { Links } from "../types";

export const systemSettingGlobalSettingLinks: Links = {
  "Warehouse Settings": {
    type: "Page",
    open: false,
    route: "warehouse-configuration-settings",
    permission: "WAREHOUSE_SETTINGS_READ",
    subPages: [],
    icon: routeIcons.warehouseSettings,
  },
  Categories: {
    type: "Page",
    open: false,
    route: "categories",
    permission: "CATEGORIES_READ",
    subPages: [],
    icon: routeIcons.category,
  },
  Notifications: {
    type: "Page",
    open: false,
    route: "notifications",
    permission: "NOTIFICATIONS_READ",
    subPages: [],
    icon: routeIcons.notification,
  },
  Commodities: {
    type: "Page",
    open: false,
    route: "commodities",
    permission: "COMMODITIES_READ",
    subPages: [],
    icon: routeIcons.commodity,
  },
  Services: {
    type: "Page",
    open: false,
    route: "services",
    permission: "SERVICES_READ",
    subPages: [],
    icon: routeIcons.services,
  },
  Manufacturers: {
    type: "Page",
    open: false,
    route: "manufacturers",
    permission: "MANUFACTURERS_READ",
    subPages: [],
    icon: routeIcons.manufacturers,
  },
  "Project Types": {
    type: "Page",
    open: false,
    route: "project-types",
    permission: "PROJECT_TYPES_READ",
    subPages: [],
    icon: routeIcons.projectTypes,
  },
  "Vendor Types": {
    type: "Page",
    open: false,
    route: "vendor-types",
    permission: "VENDOR_TYPES_READ",
    subPages: [],
    icon: routeIcons.vendorTypes,
  },
  "R2 Grading Options": {
    type: "Page",
    open: false,
    route: "r2-grading-options",
    permission: "R2_GRADING_OPTIONS_READ",
    subPages: [],
    icon: routeIcons.r2GradingOptions,
  },
  "Certificate Templates": {
    type: "Page",
    open: false,
    route: "certificate-templates",
    permission: "CERTIFICATE_TEMPLATES_READ",
    subPages: [],
    icon: routeIcons.certificateTemplates,
  },
  "Pricing Templates": {
    type: "Page",
    open: false,
    route: "pricing-templates",
    permission: "PRICING_TEMPLATES_READ",
    subPages: [],
    icon: routeIcons.pricingTemplates,
  },
  "Printer Settings": {
    type: "Menu",
    open: false,
    route: "printer-settings",
    permission: "PRINTER_SETTINGS_READ",
    subPages: [
      { title: "Printers", route: "printers", permission: "MANAGE_PRINTERS_READ" },
      { title: "Templates", route: "print-templates", permission: "PRINT_TEMPLATES_READ" },
    ],
    icon: routeIcons.printerSettings,
  },
};

export const systemSettingAdminSettingLinks: Links = {
  "Users & Roles": {
    type: "Menu",
    open: false,
    route: "users-roles",
    permission: "USERS_AND_ROLES_MENU_READ",
    subPages: [
      {
        title: "User Management",
        route: "user-management",
        permission: "USER_MANAGEMENT_READ",
      },
      {
        title: "Roles & Permissions",
        route: "roles-permissions",
        permission: "ROLES_AND_PERMISSIONS_READ",
      },
    ],
    icon: routeIcons.usersAndRoles,
  },
  "Inventory Attributes": {
    type: "Menu",
    open: false,
    route: "inventory-attributes",
    permission: "INVENTORY_ATTRIBUTES_READ",
    subPages: [
      {
        title: "Attributes",
        route: "attributes",
        permission: "ATTRIBUTES_READ",
      },
      {
        title: "Attribute Sets",
        route: "attribute-sets",
        permission: "ATTRIBUTE_SETS_READ",
      },
    ],
    icon: routeIcons.inventoryAttributes,
  },
  "Asset Workflow": {
    type: "Menu",
    open: false,
    route: "asset-workflow",
    permission: "ASSET_WORKFLOW_MENU_READ",
    subPages: [
      {
        title: "Workflow Steps",
        route: "workflow-steps",
        permission: "WORKFLOW_STEPS_READ",
      },
      {
        title: "Custom Transitions",
        route: "custom-transitions",
        permission: "WORKFLOW_TRANSITION_READ",
      },
      {
        title: "System Transitions",
        route: "system-transitions",
        permission: "SYSTEM_TRANSITIONS_READ",
      },
    ],
    icon: routeIcons.assetWorkflow,
  },
  Integrations: {
    type: "Menu",
    open: false,
    route: "integrations",
    permission: "INTEGRATIONS_MENU_READ",
    subPages: [
      {
        title: "API Keys",
        route: "api-keys",
        permission: "API_KEYS_READ",
      },
      {
        title: "Email",
        route: "email",
        permission: "EMAIL_READ",
      },
      {
        title: "WipeOS",
        route: "wipeOS",
        permission: "WIPEOS_READ",
      },
      {
        title: "Dataknox Portal",
        route: "dataknox-portal",
        permission: "DATAKNOX_PORTAL_READ",
      },
    ],
    icon: routeIcons.integrations,
  },
  "General Settings": {
    type: "Page",
    open: false,
    route: "general-settings",
    permission: "GENERAL_SETTINGS_READ",
    subPages: [],
    icon: routeIcons.generalSettings,
  },
  Logs: {
    type: "Page",
    open: false,
    route: "logs",
    permission: "LOGS_READ",
    subPages: [],
    icon: routeIcons.logs,
  },
};
